import React, { useEffect } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Chip from '@material-ui/core/Chip';
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import styles from "assets/jss/material-kit-react/components/profileStyle.js";
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import download from "downloadjs"
import Axios from "axios";
import Config from "../../config.js"
import swal from 'sweetalert'


const useStyles = makeStyles(styles);

export default function Resume(props) {
  const { user } = props;
  const classes = useStyles();
  const downloadResumeFile = () => {
    
    Axios.get(Config.api + "Resume/GetResumeFile",
      {
        responseType: "blob",
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      }).then(async (result) => {
        download(result.data, 'Resume.pdf');
        swal.close()
        swal("فایل با موفقیت ایجاد شد.", {
          icon:"success"
        })
      }).catch((err) => {
        if (err && err.response && err.response.status && err.response.status === 422)
          swal("پارامترهای وارد شده نادرست است");
        else if (err && err.response && err.response.status && err.response.status === 401) {
          localStorage.removeItem('token');
          return props.history.push("/");
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }
  const downloadResume = () => {
    swal("در حال ساخت پیوند اشتراک گذاری؛ لطفا شکیبا باشید ...", {
      buttons: false,
      icon:"info",
      closeOnEsc: false,
      closeOnClickOutside: false,
    })
    Axios.post(Config.api + "Resume/ManageResumeLink",{

    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      }).then(async (result) => {
        var url="http://sharifcamp.ir/u/r/"+result.data.data.code
        var span = document.createElement("span");
span.innerHTML = "<a target='_blank' href='"+url+"' style='direction:ltr; text-algin:left; color:#999 !important' class='swal-content__input' disabled >"+url+"</a>";
    swal({
      text: 'جهت اشتراک گذاری رزومه، میتوانید از لینک زیر استفاده کنید.',
      content: span,
      buttons: {
        cancel: "برگشت",
        copy: {
          text: "کپی کردن",
          value: "copy",
          closeModal: false,
        },
        download: {
          text: "دانلود فایل",
          value: "download",
          closeModal: false,
        },
      },
    }).then((result) => {
      if(result=="copy"){
        navigator.clipboard.writeText(url);
         swal("کپی شد.", {
          buttons: false,
          timer: 1000,
          icon:"success"
        })
      }
      else if(result=="download"){
        downloadResumeFile();
      }
    })
      }).catch((err) => {
        if (err && err.response && err.response.status && err.response.status === 422)
          swal("پارامترهای وارد شده نادرست است");
        else if (err && err.response && err.response.status && err.response.status === 401) {
          localStorage.removeItem('token');
          return props.history.push("/");
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }
  

  return (
    <form noValidate autoComplete="off">
      <GridContainer className={classes.root} justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <Paper className={classes.paper} variant="outlined" >

            <GridContainer>
              <GridItem xs={12} sm={12} md={5}>
                <div className={classes.div}>
                  <Typography variant="h6" gutterBottom>
                    دریافت رزومه
      </Typography>
                  
                  
      
      </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
              <Typography variant="body2" gutterBottom>
                  جهت دریافت رزومه، لازم است ابتدا تمام تب‌های موجود در این بخش را پر کرده و اطلاعات آن را ذخیره کنید.
     <br />
     شما می‌توانید از طریق دکمه دریافت رزومه، نسبت به دریافت فایل رزومه اقدام کنید. این فایل به صورت PDF است و می‌توانید آن را با دیگران به اشتراک بگذارید.
     <br />
  همچنین خواهید توانست لینک ایجاد شده را با دیگران به اشتراک بگذارید و از آنها دعوت کنید از رزومه شما بازدید کنند.
  <br />
  توجه داشته باشید هر کسی که لینک را داشته باشد، میتواند رزومه شما را مشاهده کند. برای دیدن اینکه او چه چیزی را مشهده میکند، بر روی نمایش رزومه کلیک کنید.
      </Typography>
      </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.en + " " + classes.save}>
                  <Button variant="contained" color="primary" disableElevation onClick={downloadResume}>
                   دریافت رزومه
                </Button>
                </div>
              </GridItem>
            </GridContainer>
          </Paper>
        </GridItem>

      </GridContainer>
    </form>
  );
}